import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

function Http404() {
    const navigate = new useNavigate()

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: "100vh" }} >
            <Result
                status="404"
                title="404"
                subTitle="Página não encontrada."
                extra={<Button onClick={() => navigate('/sign-in')} type="primary">Voltar</Button>}
            />
        </div>
    );
}
export default Http404;